import * as React from 'react';
import { Link, PaletteMode, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import NavbarBack from '../components/club-vip/components/NavbarBack';
import Register from '../components/club-vip/components/Register';
import getLPTheme, { white } from '../getLPTheme';
import Copyright from '../auxiliares/Copyright'


export default function RegisterPage() {
  const [mode] = React.useState<PaletteMode>('dark');  // Cambiar a 'ligh' para que empiece con tema claro.
  const [showCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });

  return (
    <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
      <CssBaseline />
      <NavbarBack/>
      <Box sx={{ bgcolor: 'background.default' }}>
        <Divider />
        <Register />
        <Copyright/>
      </Box>
    </ThemeProvider>
  );
}
